export const FRIEND_LIST = 'FRIEND_LIST';
export const RECEIVED_REQUEST = 'RECEIVED_REQUEST';
export const SENT_REQUEST = 'SENT_REQUEST';
export const RECOMENDED_FRIEND_LIST_SUCCESS = 'RECOMENDED_FRIEND_LIST_SUCCESS' 
